import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat.js";
import duration from "dayjs/plugin/duration.js";
import isBetween from "dayjs/plugin/isBetween.js";
import isoWeek from "dayjs/plugin/isoWeek.js";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore.js";
import isToday from "dayjs/plugin/isToday.js";
import isYesterday from "dayjs/plugin/isYesterday.js";
import localeData from "dayjs/plugin/localeData.js";
import localizedFormat from "dayjs/plugin/localizedFormat.js";
import minmax from "dayjs/plugin/minMax.js";
import relativeTime from "dayjs/plugin/relativeTime.js";
import timeZone from "dayjs/plugin/timezone.js";
import toArray from "dayjs/plugin/toArray.js";
import updateLocale from "dayjs/plugin/updateLocale.js";
import utc from "dayjs/plugin/utc.js";
import weekday from "dayjs/plugin/weekday.js";

import "./locales";

dayjs.extend(customParseFormat);
dayjs.extend(isBetween);
dayjs.extend(isSameOrBefore);
dayjs.extend(isToday);
dayjs.extend(isYesterday);
dayjs.extend(isoWeek);
dayjs.extend(localizedFormat);
dayjs.extend(localeData);
dayjs.extend(relativeTime);
dayjs.extend(timeZone);
dayjs.extend(toArray);
dayjs.extend(utc);
dayjs.extend(updateLocale);
dayjs.extend(minmax);
dayjs.extend(duration);
dayjs.extend(weekday);

export type Dayjs = dayjs.Dayjs;

export type { ConfigType, ManipulateType, UnitTypeShort } from "dayjs";

export default dayjs;
